import { Grid, NumberFormatter, Text } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import classes from './InfoHistoryTable.module.css';
import { histories } from './data';
export const InfoHistoryTable: React.FC = () => {
  const isMobile = useMediaQuery('(max-width: 36em)');
  return <Grid gutter={0} mt={20}>
      {histories.map((history, index) => <Grid.Col span={{
      base: 6,
      sm: 3
    }} key={history.id}>
          {history.data.map(item => typeof item.value === 'string' ? <div key={item.value} className={index > 1 && isMobile ? classes.itemRevert : classes.item}>
                <Text c={item.color} fz={{
          base: 12,
          sm: 13
        }} p="sm" tt="capitalize">
                  {item.value}
                </Text>
              </div> : <div key={item.value} className={index > 1 && isMobile ? classes.itemRevert : classes.item}>
                <Text c={item.color} fz={{
          base: 12,
          sm: 13
        }} fw={700} p="sm">
                  <NumberFormatter value={item.value} thousandSeparator="," prefix="$" />
                </Text>
              </div>)}
        </Grid.Col>)}
    </Grid>;
};